module.exports = __webpack_public_path__ + "img/daedalus_logo.aa58834f.png";